import { CardImag, CardText, Content, Heading, Section, TextDiscretion, TitleRaeteng, Image, Card, TextResult, TextSearched, ContentNotFound, ImageNotFound } from "../StyLedSearchResualt"
import { RatingComponent } from "../../../../Components/Form"
import { Circle } from '../../../../images';
import { Link } from "react-router-dom";
import Search from './search.svg'
import HookNavbar from '../../../../hooks/hook-navbar/index';
import SearchLottie from '../../../../Components/Loader/lotile/Search/SearchLotile';
import { Fade } from "react-reveal";

const SearchList = () => {
    const { LoadsearchCourse, datasearchCourse, fetshResult, search } = HookNavbar()
    return (
        <Section>
            <Fade>
                <TextResult>
                    "<TextSearched>{search}</TextSearched>"
                    عدد النتائج({datasearchCourse?.data?.data?.courses.length})
                </TextResult>
                {
                    !fetshResult && !LoadsearchCourse && datasearchCourse ?
                        datasearchCourse?.data?.data?.courses.length == 0 ? (
                            <ContentNotFound>
                                <ImageNotFound src={Search} alt='' />
                                <TextResult>
                                    لا توجد نتائج!
                                </TextResult>
                                <TextSearched style={{ fontSize: '16px' }} >
                                    جرب شيئا آخر...
                                </TextSearched>
                            </ContentNotFound>
                        ) : (<Content>
                            {
                                !fetshResult && !LoadsearchCourse && datasearchCourse ?
                                    datasearchCourse?.data?.data?.courses.map((card) => (
                                        <Link style={{ textDecoration: 'none' }} to={`/about-course/${card.id}`}>
                                            <Card key={card.id} >
                                                <CardImag>
                                                    <Image src={`${process.env.REACT_APP_BASE_URL}${card.image_path}`} alt={card.name} />
                                                </CardImag>
                                                <CardText>
                                                    <Heading>
                                                        {card.name}
                                                    </Heading>
                                                    <TitleRaeteng>
                                                        <RatingComponent value={card.rate} readOnly={true} />
                                                    </TitleRaeteng>
                                                    <TextDiscretion>
                                                        {card.teacher_name}
                                                        {/* <img src={Circle} style={{ margin: '5px 7px' }} alt="circle" />  */}
                                                        {/* {card.date_of_create} */}
                                                    </TextDiscretion>
                                                </CardText>
                                            </Card>
                                        </Link>
                                    )) : <><SearchLottie /></>
                            }
                        </Content>)

                        : <><SearchLottie /></>}
            </Fade>
        </Section>
    )
}

export default SearchList